module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("All Domains")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--info pull-right",
    attrs: {
      "to": "/admin/create-domain/"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus el-icon-left"
  }), _vm._v("\n                    Create Domain\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body domain-list"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "height": "400",
      "data": _vm.domains
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('img', {
          staticClass: "round",
          attrs: {
            "width": "30",
            "height": "30",
            "avatar": ("" + (scope.row.name))
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "300",
      "label": "",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": ("" + ('/admin/publisher/' + props.row.publisher.uuid + '/domain/edit/' + props.row.id))
          }
        }, [_c('span', {
          staticClass: "domain-name"
        }, [_vm._v(_vm._s(("" + (props.row.name))))]), _vm._v(" "), _c('span', {
          staticClass: "publisher-name"
        }, [_vm._v(_vm._s(("" + (props.row.publisher.name))))]), _vm._v(" "), (props.row.dfp_network != null) ? _c('span', {
          staticClass: "dfp-network-alias"
        }, [_vm._v(_vm._s(("" + (props.row.dfp_network.display_name))) + " DFP")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Reports",
      "prop": "Reports",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "Reports",
            "placement": "bottom"
          }
        }, [_c('router-link', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          attrs: {
            "to": ("" + ('/admin/publisher/' +
                                        props.row.publisher.id +
                                        '/ReportsRevenue/' +
                                        props.row.id))
          }
        }, [_c('i', {
          staticClass: "fa fa-line-chart",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_c('el-badge', {
          staticClass: "item",
          attrs: {
            "value": 0,
            "max": 10
          }
        }, [_c('el-button', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: (props.row.site_tag),
            expression: "props.row.site_tag",
            arg: "copy"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:success",
            value: (_vm.onCopy),
            expression: "onCopy",
            arg: "success"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:error",
            value: (_vm.onError),
            expression: "onError",
            arg: "error"
          }],
          staticClass: "notes-box",
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_c('span', [_c('svg', {
          staticClass: "svg-inline--fa fa-copy fa-w-14 fa-2x",
          attrs: {
            "width": "17px",
            "height": "17px",
            "aria-hidden": "true",
            "data-prefix": "fal",
            "data-icon": "copy",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 448 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "currentColor",
            "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
          }
        })])])])], 1)], 1), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('ul', {
          staticClass: "dropdown-menu-devin",
          staticStyle: {
            "max-width": "700px !important"
          }
        }, [_c('li', {
          staticClass: "header",
          staticStyle: {
            "margin": "5px",
            "font-size": "12px"
          }
        }, [_vm._v("\n                                            " + _vm._s(props.row.site_tag ? props.row.site_tag : 'No Script Present.') + "\n                                        ")]), _vm._v(" "), _c('li', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-left": "20px",
            "font-size": "10px"
          }
        }, [_c('b', [_vm._v("copied!")])])])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": ("" + ('/admin/domains/notes/' + props.row.id))
          }
        }, [_c('el-button', {
          staticClass: "notes-box",
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_c('span', [_c('svg', {
          staticClass: "svg-inline--fa fa-pen-square fa-w-14 fa-2x",
          attrs: {
            "width": "17px",
            "height": "17px",
            "aria-hidden": "true",
            "data-prefix": "far",
            "data-icon": "pen-square",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 448 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "currentColor",
            "d": "M246.6 177.9l55.5 55.5c2.3 2.3 2.3 6.1 0 8.5L166.4 377.6l-57.1 6.3c-7.6.8-14.1-5.6-13.3-13.3l6.3-57.1L238 177.8c2.4-2.2 6.2-2.2 8.6.1zm98.4-12.8L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
          }
        })])])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "buckets"
        }, [_c('ul', {
          staticClass: "bucket-list clearfix",
          style: ({
            width: 122 *
              ((props.row.buckets && props.row.buckets.length) > 3 ?
                props.row.buckets.length :
                4) +
              'px',
          })
        }, _vm._l((props.row.buckets), function(bucket) {
          return _c('li', {
            key: bucket.id,
            staticClass: "shadowBox"
          }, [_c('router-link', {
            attrs: {
              "to": ("" + ('/admin/publisher/' +
                                                props.row.publisher.uuid +
                                                '/domain/' +
                                                props.row.id +
                                                '/buckets/' +
                                                bucket.id +
                                                '/'))
            }
          }, [_c('span', {}, [_c('svg', {
            staticClass: "svg-inline--fa fa-bitbucket fa-w-16 fa-3x",
            attrs: {
              "aria-hidden": "true",
              "width": "12",
              "height": "12",
              "data-prefix": "fab",
              "data-icon": "bitbucket",
              "role": "img",
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 512 512"
            }
          }, [_c('path', {
            attrs: {
              "fill": "currentColor",
              "d": "M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z"
            }
          })])]), _vm._v(" "), _c('span', {}, [_vm._v(" " + _vm._s(("" + (bucket.name))))])])], 1)
        }), 0)])]
      }
    }])
  }), _vm._v(" "), _c('infinite-loading', {
    attrs: {
      "slot": "append",
      "force-use-infinite-wrapper": ".el-table__body-wrapper"
    },
    on: {
      "infinite": _vm.infiniteHandler
    },
    slot: "append"
  })], 1)], 1)])]), _vm._v(" "), _c('transition', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0919a866!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/AllDomain.vue
// module id = 661
// module chunks = 2